import React from "react";
import { Card, Row, Col, Typography, Space, Progress } from "antd";

export default function UserProgressCard({ record }) {
  const enrolled = record?.enroled_count || 0;
  const started = record?.started_count || 0;
  const completed = record?.completed_count || 0;
  const total = record?.total_count || 1; // avoid division by zero

  // Assign weights
  const enrolledWeight = 0.25; // enrolled = 25% of full progress
  const startedWeight = 0.5; // started = 50%
  const completedWeight = 1; // completed = 100%

  // Calculate overall progress
  const totalProgress =
    ((enrolled * enrolledWeight +
      started * startedWeight +
      completed * completedWeight) /
      total) *
    100;

  const roundedProgress = Math.min(Math.round(totalProgress), 100);

  return (
    <Card
      style={{
        margin: "1rem",
        borderRadius: "8px",
        background: "#fafafa",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <Row gutter={[24, 16]} align="middle">
        {/* Left section: textual summary */}
        <Col xs={24} md={12}>
          <Space direction="vertical" size={8}>
            <Typography.Title level={5} style={{ margin: 0 }}>
              {record?.full_name}'s Summary
            </Typography.Title>
            <Typography.Text type="secondary">
              Total Courses: {total}
            </Typography.Text>
            <Typography.Text>
              Enrolled: {enrolled}, Started: {started}, Completed: {completed}
            </Typography.Text>
          </Space>
        </Col>

        {/* Right section: single weighted dashboard progress */}
        <Col
          xs={24}
          md={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Progress
            type="dashboard"
            percent={roundedProgress}
            steps={8} // as you mentioned
            strokeWidth={20}
            strokeColor="#52c41a"
            trailColor="rgba(0, 0, 0, 0.06)"
            format={() => `${roundedProgress}%`}
          />
        </Col>
      </Row>
    </Card>
  );
}
